import { render, staticRenderFns } from "./registration-box.vue?vue&type=template&id=085355a3&scoped=true"
import script from "./registration-box.vue?vue&type=script&lang=ts"
export * from "./registration-box.vue?vue&type=script&lang=ts"
import style0 from "./registration-box.vue?vue&type=style&index=0&id=085355a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085355a3",
  null
  
)

export default component.exports